module.exports = __webpack_public_path__ + "img/home_bbq.38c579ea.jpg";